import { useState } from "react";
import { categories, faqItems } from "../../../mocks/faqData";
import ScrollReveal from "../../../components/feature/ScrollReveal";

export default function FAQSection() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  const filtered =
    activeCategory === "all"
      ? faqItems
      : faqItems.filter((i) => i.category === activeCategory);

  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto">
          <ScrollReveal direction="up">
            <div className="flex flex-wrap justify-center gap-2 mb-10">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => {
                    setActiveCategory(cat.id);
                    setOpenIdx(0);
                  }}
                  className={`px-4 py-2 text-xs font-medium rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.id
                      ? "bg-airdoa-navy text-white"
                      : "bg-airdoa-cream text-airdoa-gray hover:text-airdoa-navy"
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </ScrollReveal>

          <div className="flex flex-col gap-3">
            {filtered.map((item, idx) => (
              <ScrollReveal key={`${activeCategory}-${idx}`} direction="up" delay={idx * 60}>
                <div className="border border-airdoa-gray-light/50 rounded-lg bg-white overflow-hidden">
                  <button
                    onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                    className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-airdoa-navy pr-4">
                      {item.q}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center shrink-0 text-airdoa-gold transition-transform duration-300">
                      <i className={`ri-${openIdx === idx ? "subtract" : "add"}-line text-lg`} />
                    </span>
                  </button>
                  {openIdx === idx && (
                    <div className="px-4 md:px-5 pb-4 md:pb-5">
                      <p className="text-sm text-airdoa-gray leading-relaxed">{item.a}</p>
                    </div>
                  )}
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}